import React from 'react';

import { TwoColumnsTableComponent } from 'baseComponents/TwoColumnsTableComponent';

import './GSM7Table.scss';
import { convertDataToReferenceTable } from 'helpers/compose-message';

interface Props {
  data: any;
}

export const GSM7Table: React.FC<Props> = (props) => {
  const convertedDataGSM = props.data
    ? convertDataToReferenceTable(props.data)
    : [];
  return (
    <div className='reference-table-wrapper'>
      <TwoColumnsTableComponent items={convertedDataGSM} />
    </div>
  );
};
